import { render, staticRenderFns } from "./LastPartnerOrder.vue?vue&type=template&id=763804cd&"
import script from "./LastPartnerOrder.vue?vue&type=script&lang=js&"
export * from "./LastPartnerOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports